import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PROMO_BANNERS, USER_PHOTOS } from "../data/site";

export default function PromoBanners() {
  return (
    <section className="py-4 md:py-8" data-testid="promo-banners-section">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-6 px-5 sm:px-8 md:grid-cols-2 md:gap-8">
        {PROMO_BANNERS.map((b, i) => (
          <motion.div
            key={b.id}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
          >
            <Link
              to="/shop"
              data-testid={`promo-banner-${b.id}`}
              aria-label={`Shop the ${b.alt} collection`}
              className="group block h-full overflow-hidden rounded-[36px] border-4 border-white shadow-xl shadow-lav-100"
            >
              <img
                src={b.image}
                alt={b.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
              />
            </Link>
          </motion.div>
        ))}

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          <Link
            to="/shop"
            data-testid="promo-banner-grow-freely"
            aria-label="Shop the grow freely rompers collection"
            className="group flex h-full overflow-hidden rounded-[36px] border-4 border-white bg-gradient-to-br from-butter-50 via-white to-blush-50 shadow-xl shadow-lav-100"
          >
            <div className="flex flex-1 flex-col justify-center gap-3 px-7 py-10 sm:px-9">
              <p className="text-[11px] font-bold uppercase tracking-[0.24em] text-blush-700">
                Sparkwear
              </p>
              <h3 className="font-display text-3xl font-semibold leading-tight text-ink md:text-4xl">
                Grow freely.
              </h3>
              <p className="max-w-[230px] text-sm leading-relaxed text-muted md:text-base">
                Cosy rompers &amp; onesies for 6 months to 2 years
              </p>
              <span className="mt-3 inline-flex w-fit items-center gap-2 rounded-full bg-ink px-6 py-3 font-display text-sm font-semibold text-white shadow-lg transition-transform duration-300 group-hover:scale-[1.04]">
                Shop Now
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </span>
            </div>
            <div className="relative hidden w-[45%] sm:block">
              <img
                src={USER_PHOTOS.romperWhite}
                alt="Cloud Panda romper for babies"
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
              />
            </div>
          </Link>
        </motion.div>
      </div>
    </section>
  );
}
